import { emitShopifyEvent, dialogStack } from '../services/analytics.service';
import { hideOverlay, showOverlay, whenNotShownInOverlay } from './Overlay';
import { TABBABLE_ELEMENT_SELECTOR } from '../services/accessibility.service';
import { INLINE_CART_SHOW, INLINE_CART_CLOSE } from '../constants/events.constants';
import { renderCartContents } from '../helpers/cart.helper';
import { onCartUpdate, cartState } from '../services/cart.service';
import { updateSidePanelBannerOffset } from '../helpers/side-panel-banner';
export default (() => {
    console.log('UNTUCKit : Module : InlineCart : loaded');
    const inlineCart = () => document.querySelector('.js-inline-cart');
    const checkoutButton = () => document.querySelector('.js-checkout');
    const setShown = (selector, shown) => {
        document.querySelectorAll(selector).forEach((element) => {
            element.style.display = shown ? '' : 'none';
        });
    };
    const setAccessibility = (element, hidden) => {
        element.setAttribute('aria-hidden', hidden ? 'true' : 'false');
        element.tabIndex = hidden ? -1 : 0;
    };
    const renderCart = (cartData) => {
        console.log('UNTUCKit : Module : InlineCart : renderCart');
        const cartContents = document.querySelector('.js-cart-contents');
        const checkout = checkoutButton();
        const currency = window.UNTUCKitConfig.cartCurrencySymbol;
        if (cartData.items.length) {
            setShown('.js-cart-bottom, .js-cart-subtotal', true);
            if (checkout) {
                checkout.disabled = false;
            }
        }
        else {
            if (cartContents) {
                cartContents.innerHTML = '<div class="cart-empty">Your Cart is Currently Empty.</div>';
            }
            setShown('.js-cart-bottom, .js-cart-subtotal', false);
            if (checkout) {
                checkout.disabled = true;
            }
        }
        const countLabel = `${cartData.item_count}`;
        document.querySelectorAll('.js-cart-qty').forEach((element) => {
            element.innerHTML = countLabel;
        });
        const sideCartQty = document.querySelector('.js-side-cart-qty');
        if (sideCartQty) {
            sideCartQty.innerHTML = cartData.item_count
                ? `(${cartData.item_count} item${cartData.item_count > 1 ? 's' : ''})`
                : '';
        }
        const price = document.querySelector('.js-cart-total-price');
        if (price) {
            price.innerHTML = cartData.total_price ? currency + (cartData.total_price / 100).toFixed(2) : '';
        }
    };
    async function updateCartUI(cartData) {
        console.log('UNTUCKit : Module : InlineCart : updateCart');
        await renderCartContents(cartData);
        if (!isInlineCartShown()) {
            adaHide();
        }
        renderCart(cartData);
    }
    function show() {
        console.log('UNTUCKit : Module : InlineCart : show');
        const cart = inlineCart();
        document.documentElement.classList.add('cart-opened');
        updateSidePanelBannerOffset();
        cart?.classList.add('is-active');
        showOverlay('inline-cart');
        adaShow();
        const cartData = cartState.get();
        if (cartData) {
            emitShopifyEvent('view_cart', cartData);
        }
        dialogStack.push('inline-cart');
    }
    function hide() {
        console.log('UNTUCKit : Module : InlineCart : hide');
        if (!isInlineCartShown()) {
            return;
        }
        document.documentElement.classList.remove('cart-opened');
        inlineCart()?.classList.remove('is-active');
        hideOverlay();
        adaHide();
        dialogStack.pop('inline-cart');
    }
    function onOpenCartClick(event) {
        console.log('UNTUCKit : Module : InlineCart : .js-open-cart click');
        event.preventDefault();
        event.stopPropagation();
        if (isInlineCartShown()) {
            hide();
        }
        else {
            show();
        }
    }
    function onCloseCartClick(event) {
        console.log('UNTUCKit : Module : InlineCart : .js-close-cart click');
        event.preventDefault();
        event.stopPropagation();
        hide();
    }
    function onBodyClick() {
        document.querySelectorAll('.js-tooltip').forEach((tooltip) => {
            tooltip.nextElementSibling?.classList.remove('is-active');
        });
    }
    function onTooltipClick(event) {
        if (!(event.currentTarget instanceof HTMLElement)) {
            return;
        }
        event.currentTarget.nextElementSibling?.classList.toggle('is-active');
    }
    function bindUIActions() {
        console.log('UNTUCKit : Module : InlineCart : bindUIActions');
        document.querySelectorAll('.js-open-cart').forEach((trigger) => {
            trigger.addEventListener('click', onOpenCartClick);
        });
        document.querySelector('.js-close-cart')?.addEventListener('click', onCloseCartClick);
        onCartUpdate.subscribe((cart) => updateCartUI(cart));
        window.addEventListener(INLINE_CART_SHOW, () => show());
        window.addEventListener(INLINE_CART_CLOSE, () => hide());
        document.body.addEventListener('click', onBodyClick);
        document.querySelectorAll('.js-tooltip').forEach((tooltip) => {
            tooltip.addEventListener('click', onTooltipClick);
            tooltip.parentElement?.addEventListener('click', (event) => {
                event.stopPropagation();
            });
        });
        adaHide();
        whenNotShownInOverlay('inline-cart').subscribe(() => hide());
        let bannerOffsetFrame = 0;
        window.addEventListener('resize', () => {
            if (!isInlineCartShown()) {
                return;
            }
            cancelAnimationFrame(bannerOffsetFrame);
            bannerOffsetFrame = requestAnimationFrame(updateSidePanelBannerOffset);
        });
    }
    function init() {
        console.log('UNTUCKit : Module : InlineCart : init');
        bindUIActions();
        adaHide();
    }
    function adaShow() {
        console.log('UNTUCKit : Module : InlineCart : adaShow');
        const cart = inlineCart();
        if (!cart) {
            return;
        }
        setAccessibility(cart, false);
        cart.querySelectorAll(TABBABLE_ELEMENT_SELECTOR).forEach((element) => {
            setAccessibility(element, false);
        });
        cart.focus();
    }
    function adaHide() {
        console.log('UNTUCKit : Module : InlineCart : adaHide');
        const cart = inlineCart();
        if (!cart) {
            return;
        }
        setAccessibility(cart, true);
        cart.querySelectorAll(TABBABLE_ELEMENT_SELECTOR).forEach((element) => {
            setAccessibility(element, true);
        });
    }
    function isInlineCartShown() {
        return inlineCart()?.classList.contains('is-active') ?? false;
    }
    return { init };
})();
